export default __webpack_public_path__ + "static/media/D_sound.bb0476b7.mp3";